/*
 * Project: forca
 * File Created: Wednesday, 1st December 2021 9:27:01 am
 * Author: Teodor Moquist (teodor@moquist.dk)
 */

import React from 'react';

import { QuoteBlockProps } from './quoteBlock.definition';

export const QuoteBlock = (props: QuoteBlockProps) => {
	const { quote, cite, author, elementMargin } = props;

	if (!quote) {
		return null;
	}

	return (
		<figure
			className={ [
				'QuoteBlock',
				elementMargin ? `mb-${elementMargin}` : ''
			].join(' ') }
		>
			<p className="QuoteBlock-Quote">
				<q cite={ cite }>
					{ quote }
				</q>
			</p>
			{ author && (
				<figcaption className="QuoteBlock-Author">
					{ author }
				</figcaption>
			) }
		</figure>
	);
};

export default QuoteBlock;